import { DayHours } from '@models/day-hours.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NotificationsService, ObservatoryService } from '@app/services/services.module';
import { TranslateService } from '@ngx-translate/core';
import { RangeHourService } from '@services/range-hour/range-hour.service';
import { UtilsService } from '@services/utils/utils.service';

@Component({
  selector: 'app-time-control',
  templateUrl: './time-control.component.html',
  styleUrls: ['./time-control.component.scss']
})
export class TimeControlComponent implements OnInit {

  dayHours: DayHours[];
  @Input() data;
  @Input() workingDay;
  @Output() update: EventEmitter<any> = new EventEmitter();

  startTime: Date;
  endTime: Date;
  startTimeTxt;
  endTimeTxt;

  endTimeChanged: boolean;
  breakTime;
  timeInPerson;
  excessOfTime;

  constructor(
    private notification: NotificationsService,
    private observatoryService: ObservatoryService,
    public translate: TranslateService,
    public rangeHourService: RangeHourService,
    public utilsService: UtilsService
  ) { }

  ngOnInit() {

    // llenamos la array de horas
    this.dayHours = this.rangeHourService.newArrayHours();
    if (this.data.length > 0) {
      // transformamos la data, para poder trabajar con ella
      if (this.data[0].endTime === '00:00:00') {
        this.data[0].endTime = '24:00:00';
      }
      // copiamos la data para evitar errores al borrar
      if (this.data[0].endTime) {
        this.endTimeTxt = this.data[0].endTime;
      }
      if (this.data[0].startTime) {
        this.startTimeTxt = this.data[0].startTime;
      }
      this.breakTime = this.data[0].breakTime;
      if (this.breakTime) {
        this.breakTime = Number(this.breakTime).toFixed(1);
      }
    } else {
      this.endTimeTxt = '18:00:00';
      this.startTimeTxt = '09:00:00';
      this.breakTime = Number(1).toFixed(1);
    }

    this.hourChanged();
  }

  hourChanged() {

    this.startTime = new Date();
    this.startTime.setHours(Number(this.getHH(this.startTimeTxt)));
    this.startTime.setMinutes(Number(this.getMM(this.startTimeTxt)));
    this.startTime.setSeconds(Number(this.getSS(this.startTimeTxt)));
    this.endTime = new Date();
    this.endTime.setHours(Number(this.getHH(this.endTimeTxt)));
    this.endTime.setMinutes(Number(this.getMM(this.endTimeTxt)));
    this.endTime.setSeconds(Number(this.getSS(this.endTimeTxt)));

    if (this.startTime.getTime() < this.endTime.getTime()) {
      if (Number(this.breakTime) >= 0) {
        // breaktime positivo
        this.timeInPerson = this.utilsService.diffHours(this.startTime, this.endTime) - Number(this.breakTime);
      } else {
        // breaktime negativo
        this.timeInPerson = this.utilsService.diffHours(this.startTime, this.endTime) + Number(this.breakTime);
      }
      if (this.timeInPerson) {
        this.timeInPerson = Number(this.timeInPerson).toFixed(1);
      }
      this.excessOfTime = Math.round((Number(this.timeInPerson) - Number(this.workingDay)) * 100) / 100;
      if (this.excessOfTime) {
        this.excessOfTime = Number(this.excessOfTime).toFixed(1);
      }
    } else {
      this.notification.setWarning(this.translate.instant('CALENDARIO.HR_END'));
      this.timeInPerson = '0.00';
      this.excessOfTime = '0.00';
    }

    this.observatoryService.setData('timeInPerson', this.timeInPerson);
    this.observatoryService.setData('excessOfTime', this.excessOfTime);
    this.observatoryService.setData('breakTime', this.breakTime);
    this.observatoryService.setData('startTimeTxt', this.startTimeTxt);
    this.observatoryService.setData('endTimeTxt', this.endTimeTxt);
    this.changeData();
  }

  numberToString(data) {
    if (data.toString().length === 1) {
      return '0' + data;
    } else {
      return data;
    }
  }

  changeData() {
    this.update.emit();
  }

  breakTimeChanged(ev) {
    // si el breaktime es null
    if (!ev) {
      this.breakTime = 0;
    }

    if (ev >= 0) {
      if (ev > this.workingDay) {
        // this.breakTime = 0;
        this.notification.setWarning(this.translate.instant('CALENDARIO.REST_TIME_LOWER'));
      } else {
        // this.breakTime = (Math.round(this.breakTime * 2) / 2);

        // breaktime no multiplo de 0.5
        if (this.breakTime % 0.5 !== 0) {
          this.notification.setWarning(this.translate.instant('CALENDARIO.REST_TIME_MULTIPL'));
        }

        if (this.breakTime) {
          this.breakTime = Number(this.breakTime).toFixed(1);
        }
      }
    } else {
      this.notification.setWarning(this.translate.instant('CALENDARIO.REST_TIME_POSITIVE'));
      // this.breakTime = 0;
    }

    this.hourChanged();
  }

  validationStartTime(timepicker) {
    // en caso de error volvemos a los valores por defecto
    this.startTime = new Date();
    this.startTime.setHours(Number(this.getHH(this.data[0].startTime)));
    this.startTime.setMinutes(Number(this.getMM(this.data[0].startTime)));
    this.startTime.setSeconds(Number(this.getSS(this.data[0].startTime)));
    this.hourChanged();
    this.notification.setWarning(this.translate.instant('CALENDARIO.START_HR'));
  }

  validationEndTime(timepicker) {
    // en caso de error volvemos a los valores por defecto
    this.endTime = new Date();
    this.endTime.setHours(Number(this.getHH(this.data[0].endTime)));
    this.endTime.setMinutes(Number(this.getMM(this.data[0].endTime)));
    this.endTime.setSeconds(Number(this.getSS(this.data[0].endTime)));
    this.hourChanged();
    this.notification.setWarning(this.translate.instant('CALENDARIO.FIN_HR'));
  }

  private getHH(fecha): string {
    return fecha.substring(0, 2);
  }

  private getMM(fecha): string {
    return fecha.substring(3, 5);
  }

  private getSS(fecha): string {
    return fecha.substring(6, 8);
  }

}
